import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateUser } from "../../features/user";
import { useGetTenant } from "../../features/tenant";

const UserCreate = () => {
  const { create } = useCreateUser(); // Rename this if necessary
  const { tenant } = useGetTenant();

  const [formData, setFormData] = useState({
    name: "",
    username: "",
    password: "",
    role: "USER", // default role
    tenantId: "",
    phone: "",
  });

  const navigate = useNavigate();

  const handleSelectProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedProductCode = e.target.value;
    const selectedProduct = tenant?.find(
      (prod) => prod.id === selectedProductCode
    );
    if (selectedProduct) {
      setFormData({
        ...formData,
        tenantId: selectedProduct.id,
      });
    }
  };

  // Handle change for both input/textarea and select elements
  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create(formData); // Create or submit the data
    console.log("User Data Submitted:", formData);
    // Optionally redirect to another page after submitting
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Main Content */}
      <div className="flex-1 p-8">
        <h1 className="text-3xl font-bold text-center mb-8">Create New User</h1>
        <form
          onSubmit={handleSubmit}
          className="max-w-2xl mx-auto bg-white p-6 shadow-md rounded-md"
        >
          {/* Name */}
          <div className="mb-4">
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          {/* Username */}
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700"
            >
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="phone"
              className="block text-sm font-medium text-gray-700"
            >
              Phone
            </label>
            <input
              type="text"
              id="phone"
              placeholder="62"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="role"
              className="block text-sm font-medium text-gray-700"
            >
              Role
            </label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            >
              <option value="USER">User</option>
              <option value="ADMIN">Admin</option>
            </select>
          </div>
          <div className="mb-4">
            <label
              htmlFor="tenantId"
              className="block text-sm font-medium text-gray-700"
            >
              Tenant
            </label>
            <select
              id="tenantId"
              name="tenantId"
              value={formData.tenantId}
              onChange={handleSelectProduct}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="">Select Tenant</option>
              {tenant?.map((prod) => (
                <option key={prod.id} value={prod.id}>
                  {prod.name}
                </option>
              ))}
              {/* <option value="createNew">Create New Product</option> */}
            </select>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full mt-6 py-2 px-4 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            Add User
          </button>
          <button
            type="button"
            onClick={() => navigate("/user")} // Navigate to user listing or another page
            className="w-full mt-6 py-2 px-4 bg-gray-400 text-white font-medium rounded-md focus:outline-none focus:ring-2"
          >
            Back
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserCreate;
